/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-09-19 10:17:23
 * @LastEditTime: 2019-09-25 16:28:43
 * @LastEditors: Please set LastEditors
 */
function google() {
  return `
  window.gtagPageView = function() {
    gtag('event', 'conversion', {
      'send_to': 'AW-613026312/vERaCLLgstgBEIiUqKQC'
    });
  }
  window.gtag_report_conversion = function(url) {
    var callback = function () {
      if (typeof (url) != 'undefined') {
        window.location = url;
      }
    };
    gtag('event', 'conversion', {
      'send_to': 'AW-613026312/uesnCLLxo9gBEIiUqKQC',
      'event_callback': callback
    });
    return false;
  }
  `;
}

function tiktok() {
  return `(function() {
    var ta = document.createElement('script'); ta.type = 'text/javascript'; ta.async = true;
    ta.src = 'https://analytics.tiktok.com/i18n/pixel/sdk.js?sdkid=BSCIFETBA6LC1K03MJQ0';
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ta, s);
  })();
  `
}


function maidian(channel) {
  let mdStr;
  if (channel.includes('youtube')) {
    mdStr = {
      script: [
        { src: 'https://www.googletagmanager.com/gtag/js?id=AW-613026312', async: true },
        { innerHTML: google(), type: 'text/javascript'}
      ],
      __dangerouslyDisableSanitizers: ['script'],
    }
  } else if (channel.includes('tiktok')) {
    mdStr = {
      script: [
        { innerHTML: tiktok(), type: 'text/javascript'}
      ],
      __dangerouslyDisableSanitizers: ['script']
    }
  } else if (channel.includes('facebook')) {
    mdStr = {
      script: [
        { innerHTML: '//no facebook maidian', type: 'text/javascript'}
      ],
      __dangerouslyDisableSanitizers: ['script']
    }
  } else {
      mdStr = {
        script: [
          { innerHTML: '//no maidian', type: 'text/javascript'}
        ],
        __dangerouslyDisableSanitizers: ['script']
      }
  }
  return mdStr
}
export {
  maidian
}
